import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import iView from 'lb-iview'
import {VNode} from 'vue'

let IView: any = iView

export interface DrawerPropsI {
	/**
	 * 抽屉是否显示，可使用 v-model 双向绑定数据。
	 * @default false
	 */
	value?: boolean;
	/**
	 * 抽屉标题，如果使用 slot 自定义了页头，则 title 无效
	 */
	title?: string;
	/**
	 * 抽屉宽度。左/右打开时单位为 px，上/下打开时单位为 %，默认为 256
	 * @default 256
	 */
	width?: number | string;
	/**
	 * 是否显示关闭按钮
	 * @default true
	 */
	closable?: boolean;
	/**
	 * 是否允许点击遮罩层关闭
	 * @default true
	 */
	'mask-closable'?: boolean;
	/**
	 * 抽屉打开的方向，可选值为 top / bottom / left / right
	 * @default right
	 */
	placement?: 'top' | 'bottom' | 'left' | 'right';
	/**
	 * 是否显示遮罩层
	 * @default true
	 */
	mask?: boolean;
	/**
	 * 遮罩层样式
	 */
	'mask-style'?: object;
	/**
	 * 抽屉外层样式
	 */
	styles?: object;
	/**
	 * 抽屉外层类名
	 */
	'class-name'?: string;
	/**
	 * 是否将抽屉放置于 body 内
	 * @default false
	 */
	transfer?: boolean;
	/**
	 * 是否开启拖拽调整宽度
	 * @default false
	 */
	draggable?: boolean;
	/**
	 * slot插槽对象
	 */
	$slots?: {
		/**
		 * 抽屉主体内容
		 */
		'': VNode[];
		/**
		 * 自定义页头
		 */
		header: VNode[];
	};
}

export interface DrawerEventI {
	onOnClose(): void
}

const Drawer = Vue.ofType<DrawerPropsI, DrawerEventI>().convert(IView.Drawer);
export default Drawer
